import { useEffect, useRef, useState } from 'react';

export default function CursorEffect() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [hovering, setHovering] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    let ringX = 0, ringY = 0, mouseX = 0, mouseY = 0;
    let rafId;

    const onMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (!visible) setVisible(true);
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
      }
    };

    const animate = () => {
      ringX += (mouseX - ringX) * 0.1;
      ringY += (mouseY - ringY) * 0.1;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ringX}px, ${ringY}px)`;
      }
      rafId = requestAnimationFrame(animate);
    };

    const onOver = (e) => {
      if (e.target.closest('a, button, [role="button"], input, textarea, select')) {
        setHovering(true);
      }
    };

    const onOut = (e) => {
      if (e.target.closest('a, button, [role="button"], input, textarea, select')) {
        setHovering(false);
      }
    };

    const onLeave = () => setVisible(false);
    const onEnter = () => setVisible(true);

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseover', onOver);
    document.addEventListener('mouseout', onOut);
    document.addEventListener('mouseleave', onLeave);
    document.addEventListener('mouseenter', onEnter);
    animate();

    return () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseover', onOver);
      document.removeEventListener('mouseout', onOut);
      document.removeEventListener('mouseleave', onLeave);
      document.removeEventListener('mouseenter', onEnter);
      cancelAnimationFrame(rafId);
    };
  }, [visible]);

  return (
    <>
      {/* Dot */}
      <div
        ref={dotRef}
        style={{
          position: 'fixed',
          top: 0, left: 0,
          width: hovering ? '6px' : '5px',
          height: hovering ? '6px' : '5px',
          background: '#00F0FF',
          borderRadius: '50%',
          pointerEvents: 'none',
          zIndex: 99999,
          marginLeft: hovering ? '-3px' : '-2.5px',
          marginTop: hovering ? '-3px' : '-2.5px',
          opacity: visible ? 1 : 0,
          transition: 'width 0.2s, height 0.2s, opacity 0.3s',
          willChange: 'transform',
          boxShadow: '0 0 8px rgba(0,240,255,0.9)',
        }}
      />
      {/* Ring */}
      <div
        ref={ringRef}
        style={{
          position: 'fixed',
          top: 0, left: 0,
          width: hovering ? '44px' : '28px',
          height: hovering ? '44px' : '28px',
          border: `1px solid ${hovering ? 'rgba(0,240,255,0.8)' : 'rgba(255,255,255,0.35)'}`,
          borderRadius: '50%',
          pointerEvents: 'none',
          zIndex: 99998,
          marginLeft: hovering ? '-22px' : '-14px',
          marginTop: hovering ? '-22px' : '-14px',
          opacity: visible ? 1 : 0,
          transition: 'width 0.3s ease, height 0.3s ease, border-color 0.3s ease, opacity 0.3s, margin 0.3s ease',
          willChange: 'transform',
          background: hovering ? 'rgba(0,240,255,0.05)' : 'transparent',
        }}
      />
    </>
  );
}
